import styled from '@emotion/styled';

export const MainBlock = styled.div`
  color: ${({ theme }) => theme.colors.WhiteGray};

  display: flex;
  align-items: center;

  gap: 6px;
`;

export const IconWrapper = styled.div`
  width: 24px;
  min-width: 24px;

  height: 100%;
  min-height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: help;
`;
